import { useQuery } from '@tanstack/react-query'
import { getProjectVideos } from '@/services/youtube.service'
import { YOUTUBE_VIDEOS_QUERY_KEY } from '@/hooks/useAddYouTubeVideo'

export const useYouTubeVideos = (projectId: number) => {
  return useQuery({
    queryKey: [YOUTUBE_VIDEOS_QUERY_KEY, projectId],
    queryFn: () => getProjectVideos(projectId),
    select: (data) => data.videos,
    enabled: !!projectId,
  })
}
